import { Outlet } from "react-router-dom"

const Knowledge = () => {
  return <Outlet />
}

export default Knowledge
